const getAnalyticsEventCenter = require('../common/getAnalyticsEventCenter');
const analyticsEventCenter = getAnalyticsEventCenter();

/**
 * Publish Analytics Event Cart Exit intent
 */
function publishAnalyticsEvent() {
    analyticsEventCenter.publish(
        analyticsEventCenter.EVENTS.userExitIntentAttempted
    );
}

/**
 * Sets user exit intents observer by three events:
 * - visibilitychange
 * - blur
 * - mouse leave
 */
function setExitObserver() {
    // Tab switching or minimisation
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            publishAnalyticsEvent();
        }
    });

    // Loss of focus (click outside, navigation bar, etc.)
    window.addEventListener('blur', () => {
        publishAnalyticsEvent();
    });

    // detect mouse movement anywhere outside the website (desktop only)
    document.addEventListener('mouseleave', () => {
        publishAnalyticsEvent();
    });
}

module.exports = {
    setExitObserver: setExitObserver
};
